module.exports = __webpack_public_path__ + "static/media/login.0fd01085.svg";